export const CONFIGURE_FREE_SIGNUP_STORAGE_KEY = 'content:configureFreeSignup:dismissed';
